module.exports = __webpack_public_path__ + "img/3icon.37206504.png";